import type { Event, IncompleteEvent } from '../../../../types/DirectusSchema';
import { notEmpty } from '../../lib/notEmpty.ts';

export const parseEventDetails = (eventDetails: IncompleteEvent['event_details'] | Event['event_details']) => {
  const parsedEventDetails = eventDetails
    ?.map((eventDetail) => (typeof eventDetail === 'object' ? eventDetail : null))
    .filter(notEmpty);

  // Maps over each event detail and extracts the id and event_details_id if they are valid objects
  return parsedEventDetails?.map((eventDetail) => ({
    id: eventDetail.id,
    event_details_id: typeof eventDetail.event_details_id === 'object' ? eventDetail.event_details_id : null,
  }));
};
